var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.667 4)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.919 10H4.06C1.817 10 0 11.84 0 14.11v10.557h8.127v-10.55c0-.143-.006-.285-.023-.427h3.815a.758.758 0 00.748-.757v-2.17a.755.755 0 00-.748-.763z",
    fill: "#2175D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.615 10h-7.869a.757.757 0 00-.746.757v2.175c0 .414.338.757.746.757h3.836c-.012.142-.024.284-.024.425v10.553h8.109V14.114C26.672 11.844 24.86 10 22.615 10z",
    fill: "#E74536"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2175D9",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E74536",
    cx: 22.667,
    cy: 4,
    r: 4
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIuNjY3IDQpIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGZpbGw9Im5vbmUiPgogICAgICAgIDxwYXRoIGQ9Ik0xMS45MTkgMTBINC4wNkMxLjgxNyAxMCAwIDExLjg0IDAgMTQuMTF2MTAuNTU3aDguMTI3di0xMC41NWMwLS4xNDMtLjAwNi0uMjg1LS4wMjMtLjQyN2gzLjgxNWEuNzU4Ljc1OCAwIDAgMCAuNzQ4LS43NTd2LTIuMTdhLjc1NS43NTUgMCAwIDAtLjc0OC0uNzYzeiIgZmlsbD0iIzIxNzVEOSIvPgogICAgICAgIDxwYXRoIGQ9Ik0yMi42MTUgMTBoLTcuODY5YS43NTcuNzU3IDAgMCAwLS43NDYuNzU3djIuMTc1YzAgLjQxNC4zMzguNzU3Ljc0Ni43NTdoMy44MzZjLS4wMTIuMTQyLS4wMjQuMjg0LS4wMjQuNDI1djEwLjU1M2g4LjEwOVYxNC4xMTRDMjYuNjcyIDExLjg0NCAyNC44NiAxMCAyMi42MTUgMTB6IiBmaWxsPSIjRTc0NTM2Ii8+CiAgICAgICAgPGNpcmNsZSBmaWxsPSIjMjE3NUQ5IiBjeD0iNCIgY3k9IjQiIHI9IjQiLz4KICAgICAgICA8Y2lyY2xlIGZpbGw9IiNFNzQ1MzYiIGN4PSIyMi42NjciIGN5PSI0IiByPSI0Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgPublic as ReactComponent };